/* =============================================================
   v6 Cart Drawer JS — Brief #88
   Toast, quick-add, shipping bar animation, recently-viewed.
   ============================================================= */

// ── Toast ──────────────────────────────────────────────────────

window.showToast = function (html, action) {
  const toast = document.querySelector('[data-toast]');
  if (!toast) return;

  const iconClass = html.includes('error') ? 'v6-toast__icon--error' : 'v6-toast__icon--success';
  const iconGlyph = html.includes('error') ? '!' : '✓';
  let content = `<span class="v6-toast__icon ${iconClass}">${iconGlyph}</span><span>${html}</span>`;
  if (action) {
    content += `<a href="${action.href}" class="v6-toast__action">${action.label}</a>`;
  }
  toast.innerHTML = content;
  toast.classList.add('is-visible');

  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 3500);
};

// ── Quick-add (upsell + / buttons) ────────────────────────────

function bindQuickAdd(root) {
  root.querySelectorAll('[data-quick-add]').forEach((btn) => {
    if (btn._v6Bound) return;
    btn._v6Bound = true;
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      const ariaLabel = btn.getAttribute('aria-label') || '';
      const productTitle = ariaLabel.replace(/^Add\s+/i, '').replace(/\s+to\s+bag$/i, '') || 'item';

      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = '…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        if (res.ok) {
          window.showToast(
            `In your bag — <em>${productTitle}</em>.`,
            { href: '/cart', label: 'View bag →' }
          );
          if (window.refreshCartDrawer) {
            window.refreshCartDrawer();
          } else if (window.eventBus) {
            // Trigger section render refresh
            window.eventBus.emit('render:cart:drawer');
          }
        } else {
          window.showToast('Could not add — try again.', null);
        }
      } catch (err) {
        window.showToast('Could not add — try again.', null);
      } finally {
        btn.disabled = false;
        btn.textContent = originalText;
      }
    });
  });
}

// Bind on initial load + re-bind after cart re-renders
document.addEventListener('DOMContentLoaded', () => {
  bindQuickAdd(document);
});

if (typeof window !== 'undefined' && window.eventBus) {
  window.eventBus.on('update:cart:drawer', () => {
    setTimeout(() => bindQuickAdd(document), 100);
  });
  window.eventBus.on('render:cart:drawer', () => {
    setTimeout(() => bindQuickAdd(document), 100);
  });
}

// Fallback: observe DOM changes to bind new quick-add buttons
const _quickAddObserver = new MutationObserver(() => {
  bindQuickAdd(document);
});

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) {
    _quickAddObserver.observe(drawer, { childList: true, subtree: true });
  }
  // Re-bind after any eventBus update (eventBus may load after this script)
  const tryBind = () => {
    if (window.eventBus) {
      window.eventBus.on('update:cart:drawer', () => setTimeout(() => bindQuickAdd(document), 120));
      window.eventBus.on('render:cart:drawer', () => setTimeout(() => bindQuickAdd(document), 120));
    } else {
      setTimeout(tryBind, 200);
    }
  };
  tryBind();
});

// ── Shipping bar animation ─────────────────────────────────────

function updateShippingBar(drawerEl) {
  const bar = drawerEl ? drawerEl.querySelector('[data-shipping-bar]') : document.querySelector('[data-shipping-bar]');
  if (!bar) return;

  const threshold = parseInt(bar.dataset.threshold || '5900', 10);
  const fill = bar.querySelector('.v6-cart__shipping-fill');
  const textEl = bar.querySelector('[data-shipping-text]');
  if (!fill || !textEl) return;

  // Fetch current cart total
  fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      const total = cart.total_price;
      const pct = Math.min((total / threshold) * 100, 100);
      fill.style.width = pct + '%';

      const remaining = threshold - total;
      if (remaining > 0) {
        const formatted = (remaining / 100).toFixed(2).replace(/\.00$/, '');
        textEl.innerHTML = `<span class="v6-cart__shipping-eyebrow"><strong class="v6-cart__shipping-amount">$${formatted}</strong> away from free shipping</span>`;
      } else {
        textEl.innerHTML = `<span class="v6-cart__shipping-unlocked"><em>Free shipping unlocked.</em></span>`;
      }
    })
    .catch(() => {});
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.eventBus) {
    window.eventBus.on('update:cart:drawer', () => setTimeout(updateShippingBar, 80));
  }
});

// ── Recently-viewed (localStorage) ────────────────────────────

(function () {
  const KEY = 'v6-recently-viewed';

  // On PDP: record the current product
  if (document.body.classList.contains('template-product')) {
    const pdpMeta = document.querySelector('.v6-pdp[data-product-handle]');
    if (pdpMeta) {
      const handle = pdpMeta.dataset.productHandle;
      const title = pdpMeta.dataset.productTitle || '';
      const image = pdpMeta.dataset.productImage || '';
      const url = pdpMeta.dataset.productUrl || ('/products/' + encodeURIComponent(handle));
      const imageAlt = pdpMeta.dataset.productImageAlt || title;
      const price = pdpMeta.dataset.productPrice || '';

      if (handle) {
        const stored = JSON.parse(localStorage.getItem(KEY) || '[]');
        const filtered = stored.filter((p) => p.handle !== handle);
        filtered.unshift({ handle, title, image, imageAlt, url, price });
        localStorage.setItem(KEY, JSON.stringify(filtered.slice(0, 8)));
      }
    }
  }

  // On cart open: populate recently-viewed in empty state
  function populateRecentlyViewed() {
    const container = document.querySelector('[data-recently-viewed]');
    if (!container) return;

    // Earlier records lacked product metadata. Leave the featured fallback
    // in place until those products are revisited and their entries refreshed.
    const stored = JSON.parse(localStorage.getItem(KEY) || '[]')
      .filter((item) => item && item.handle && item.title);
    if (stored.length === 0) return;

    container.innerHTML = '';
    stored.slice(0, 4).forEach((item) => {
      const card = document.createElement('a');
      card.href = !item.url || item.url === '/' + item.handle
        ? '/products/' + encodeURIComponent(item.handle)
        : item.url;
      card.className = 'v6-cart__upsell__card';
      const image = document.createElement(item.image ? 'img' : 'div');
      image.className = 'v6-cart__upsell__img';
      if (item.image) {
        image.src = item.image;
        image.alt = item.imageAlt || item.title;
        image.width = 200;
        image.height = 200;
        image.loading = 'lazy';
      }
      const body = document.createElement('div');
      body.className = 'v6-cart__upsell__body';
      const title = document.createElement('div');
      title.className = 'v6-cart__upsell__title';
      title.textContent = item.title.substring(0, 28);
      const price = document.createElement('div');
      price.className = 'v6-cart__upsell__price';
      price.textContent = item.price || '';
      body.append(title, price);
      card.append(image, body);
      container.appendChild(card);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    populateRecentlyViewed();
    if (window.eventBus) {
      window.eventBus.on('drawer:opened', () => setTimeout(populateRecentlyViewed, 50));
    }
  });
})();
